import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {TableLaundryCostWrapper} from './component/table/laundryCost'
import {TableLaundryHystoryWrapper} from './component/table/laundryHystory'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
const LaundryBillingReportTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          {isAllowed('HISTORIALPESOS/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Historial de Pesos</Tab>
          )}
          {isAllowed('CECO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Centro de Costos</Tab>
          )}
        </TabList>
        {isAllowed('HISTORIALPESOS/ACCESO') && (
          <TabPanel>
            <TableLaundryHystoryWrapper />
          </TabPanel>
        )}
        {isAllowed('CECO/ACCESO') && (
          <TabPanel>
            <TableLaundryCostWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default LaundryBillingReportTab
